import { RouteConfig } from "vue-router";
import { recommendation } from "./recommendation";

export const social = (): Array<RouteConfig> => [...recommendation()];
